import type { ReactElement } from "react"
import IconAvailable from "@onestore-icons/domain-search/icon_available.svg"
import IconAvailableBlack from "@onestore-icons/domain-search/icon_available_black.svg"
import IconError from "@onestore-icons/domain-search/icon_error.svg"
import IconRecommended from "@onestore-icons/domain-search/icon_recommended.svg"
import { getBrand } from "~/lib/config"

type MainResultImageProps = {
  available: boolean
  isPhraseIdenticalToFqdn: boolean
  isCheckout?: boolean
}
export function MainResultImage({
  available,
  isPhraseIdenticalToFqdn,
  isCheckout,
}: MainResultImageProps): ReactElement {
  let iconAvailable = <IconAvailable />

  if (isCheckout && getBrand() === "home") {
    iconAvailable = <IconAvailableBlack />
  }

  const availableIcon = isPhraseIdenticalToFqdn ? (
    iconAvailable
  ) : (
    <IconRecommended />
  )

  return available ? availableIcon : <IconError />
}
